module.exports = __webpack_public_path__ + "front/img/kv.2da996b5.jpg";